import { render, staticRenderFns } from "./UploadFileInput.component.vue?vue&type=template&id=3838e422&scoped=true&"
import script from "./UploadFileInput.component.vue?vue&type=script&lang=js&"
export * from "./UploadFileInput.component.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileInput.component.vue?vue&type=style&index=0&id=3838e422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838e422",
  null
  
)

export default component.exports